import { InjectionToken } from '@angular/core';

/**
 * Shape of environment-derived values that libraries need to consume.
 *
 * Libraries must never import the per-app `environment.ts` directly — that
 * crosses an Nx scope boundary (libs cannot depend on apps). The app
 * provides this token at bootstrap from its environment, and libs inject
 * the token to read configuration values.
 *
 * Add new fields here (not to the app's environment file shape) when a
 * library needs a new environment-derived value.
 */
export interface EnvironmentConfig {
  /**
   * AES secret used to encrypt/decrypt sensitive values held in route params
   * or `localStorage` (account ids, loan applications, etc).
   */
  readonly localStorageEncryptionKey: string;
}

export const ENVIRONMENT_CONFIG = new InjectionToken<EnvironmentConfig>('ENVIRONMENT_CONFIG');
